import type { DateTime } from "luxon";
import type { Department } from "@/contexts/AuthProvider";
import { shouldBypassCallOffDialog } from "@/utils/utilFunctions";
import { DeleteRecurringOrSingleMode } from "./types";

export type OffersReplacementSearchInput = {
	start: DateTime;
	department: Department;
	isCallOffEnabled: boolean;
	isDraftMode: boolean;
	inSelfSchedulingPeriod: boolean;
	showActual: boolean;
	mode: DeleteRecurringOrSingleMode;
};

/**
 * Whether removing this shift is a call-off that offers the "search for a replacement" checkbox.
 *
 * One predicate for the removal dialog AND the Day view's walkthrough marker on the trash icon, so the
 * tour can never press a row whose dialog then shows no checkbox.
 *
 * Never for an actual row: `POST /call-off` resolves its `shiftId` through `get_shift_nurse_and_department`,
 * which reads `nurse_in_shift` only, so an actual id 404s with `error.shift.not.found` and the row is never
 * removed. Calling someone off a shift they already have a punch record for is the wrong verb anyway —
 * that is a correction, not an absence.
 */
export const offersReplacementSearch = ({
	start,
	department,
	isCallOffEnabled,
	isDraftMode,
	inSelfSchedulingPeriod,
	showActual,
	mode,
}: OffersReplacementSearchInput): boolean =>
	!showActual &&
	mode === DeleteRecurringOrSingleMode.DeleteSingle &&
	isCallOffEnabled &&
	!isDraftMode &&
	!inSelfSchedulingPeriod &&
	shouldBypassCallOffDialog(start, department);
